import React from 'react'
import { Box } from 'rebass'

export default props => <Box height="1px" width="auto" bg="grey.5" {...props} />
